import { createSlice } from '@reduxjs/toolkit';
import { OrderExpeditionPackageDetailStateType } from 'src/types/orderExpeditionPackageDetail';

const initialState: OrderExpeditionPackageDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
};
export const orderExpeditionPackageDetailSlice = createSlice({
    name: 'orderExpeditionPackageDetail',
    initialState,
    reducers: {
        getOrderExpeditionPackageDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getOrderExpeditionPackageDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getOrderExpeditionPackageDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateOrderExpeditionPackageDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateOrderExpeditionPackageDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateOrderExpeditionPackageDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        deleteOrderExpeditionPackageDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteOrderExpeditionPackageDetailFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteOrderExpeditionPackageDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        clearOrderExpeditionPackageDetail: () => initialState,
    },
});

export const {
    getOrderExpeditionPackageDetailFetch,
    getOrderExpeditionPackageDetailFetchSuccess,
    getOrderExpeditionPackageDetailFetchFailure,
    updateOrderExpeditionPackageDetailFetch,
    updateOrderExpeditionPackageDetailFetchSuccess,
    updateOrderExpeditionPackageDetailFetchFailure,
    deleteOrderExpeditionPackageDetailFetch,
    deleteOrderExpeditionPackageDetailFetchSuccess,
    deleteOrderExpeditionPackageDetailFetchFailure,
    clearOrderExpeditionPackageDetail,
} = orderExpeditionPackageDetailSlice.actions;

export default orderExpeditionPackageDetailSlice.reducer;
